import ModalFilesList from './ModalSharedFilesList';

export default ModalFilesList;
